import { render } from "./SurveyTemplateEditor.vue?vue&type=template&id=b96b4e90"
import script from "./SurveyTemplateEditor.vue?vue&type=script&lang=js"
export * from "./SurveyTemplateEditor.vue?vue&type=script&lang=js"

import "./SurveyTemplateEditor.vue?vue&type=style&index=0&id=b96b4e90&lang=scss"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__